export enum RoutePath {
  // App paths
  APP_LINK_REDIRECT = '/redirect',
  SUPPORT = '/support',
  REMEDIATION_STUDENT_HOME = '/remediation-home',
  REMEDIATION_NEXT_RECOMMENDATION = '/remediation-next-recommendation',
  REMEDIATION_POST_PLAYER = '/remediation-post-player',
  OSMOSIS_PLAYER = '/osmosis-player',
  EBOOK_PLAYER = '/ebook-player',
  TOPIC_OVERVIEW_PLAYER = '/topic-overview-player',
  REMEDIATION_STUDENT_DETAIL = '/remediation-student-detail',
  ADMIN = '/admin',
  PLP_LIST = '/plp-list',

  // Shared paths
  TIMEOUT = '/timedOut',
  LOGIN = '/login',
  LOGOUT = '/logout',
  PAGE_NOT_FOUND = '/pageNotFound',
  HELP = '/help',
  NOT_AUTHORIZED = '/notAuthorized',
  MAINTENANCE = '/maintenance',
  UNEXPECTED_ERROR = '/unexpectedError',
}

export const ServicePath = {
  loginPath: '/login-service/login',
  tokenServicePath: '/token-service',
  userServicePath: '/apiv1/eolsUser/list',
};

export const AppConstants = {
  APP_ID: 'REMEDIATION',
  IDLE_TIMEOUT: 1000 * 60 * 60 * 6,
  PENDO_API_KEY: 'dff751fe-ca86-4722-8661-826fdb1465d8' // '94bb3f52-df30-4f69-4ec8-dceb6bffffbe'
};

export const UNKNOWN = 'UNKNOWN';
export const PERSIST_KEY = 'globalAppState';
